import {
  Media,
  ImageMedia,
  VideoMedia,
  BeneficiaryItem,
  Charity,
} from '../../types/__generated__';

export function onlyImages<T extends Pick<Media, '__typename'>>(
  media: T | ImageMedia | VideoMedia,
): media is ImageMedia {
  return media.__typename === 'ImageMedia';
}

export function notNull<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function isCharity(
  value: Pick<BeneficiaryItem, '__typename'>,
): value is Charity {
  return value.__typename === 'Charity';
}
